/* eslint-disable max-len */
import { USER_ROLES } from '@bagonboard/wiseman';

export const LF_ALL_ROLES = [
  USER_ROLES.HANDLING_COMPANY_AGENT,
  USER_ROLES.HANDLING_COMPANY_MANAGER,
  USER_ROLES.HANDLING_COMPANY_OPERATOR,
  USER_ROLES.HANDLING_COMPANY_OBSERVER,
];

export const ALL_COURIER_ROLES = [
  USER_ROLES.COURIER_ADMIN,
  USER_ROLES.AGENT,
  USER_ROLES.COURIER_AGENT,
];

export const ALL_TRAVEL_ROLES = [
  USER_ROLES.TRAVEL_COMPANY_ADMIN,
  USER_ROLES.TRAVEL_COMPANY_AGENT,
];

export const ALL_HOST_ROLES = [
  USER_ROLES.HOST_ADMIN,
  USER_ROLES.HOST_AGENT,
];

export const USER_LIST_NAMES = {
  [USER_ROLES.SUPER_ADMIN]              : 'Super Admin',
  [USER_ROLES.ADMIN]                    : 'Admin',
  [USER_ROLES.SUPPORT]                  : 'Support',
  [USER_ROLES.AGENT]                    : 'Agent',
  [USER_ROLES.COURIER_ADMIN]            : 'Courier Admin',
  [USER_ROLES.COURIER_AGENT]            : 'Courier Agent',
  [USER_ROLES.HOST_ADMIN]               : 'Host Admin',
  [USER_ROLES.HOST_AGENT]               : 'Host Agent',
  [USER_ROLES.TRAVEL_COMPANY_ADMIN]     : 'Travel Company Admin',
  [USER_ROLES.TRAVEL_COMPANY_AGENT]     : 'Travel Company Agent',
  [USER_ROLES.HANDLING_COMPANY_MANAGER] : 'L&F manager',
  [USER_ROLES.HANDLING_COMPANY_AGENT]   : 'L&F agent',
  [USER_ROLES.HANDLING_COMPANY_OPERATOR]: 'L&F operator',
  [USER_ROLES.HANDLING_COMPANY_OBSERVER]: 'L&F observer',
};

export const USER_LIST_OF_ROLES = [
  { value: USER_ROLES.SUPER_ADMIN, text: USER_LIST_NAMES[USER_ROLES.SUPER_ADMIN] },
  { value: USER_ROLES.ADMIN, text: USER_LIST_NAMES[USER_ROLES.ADMIN] },
  { value: USER_ROLES.SUPPORT, text: USER_LIST_NAMES[USER_ROLES.SUPPORT] },
  { value: USER_ROLES.AGENT, text: USER_LIST_NAMES[USER_ROLES.AGENT] },
  { value: USER_ROLES.COURIER_ADMIN, text: USER_LIST_NAMES[USER_ROLES.COURIER_ADMIN] },
  { value: USER_ROLES.COURIER_AGENT, text: USER_LIST_NAMES[USER_ROLES.COURIER_AGENT] },
  { value: USER_ROLES.HOST_ADMIN, text: USER_LIST_NAMES[USER_ROLES.HOST_ADMIN] },
  { value: USER_ROLES.HOST_AGENT, text: USER_LIST_NAMES[USER_ROLES.HOST_AGENT] },
  { value: USER_ROLES.TRAVEL_COMPANY_ADMIN, text: USER_LIST_NAMES[USER_ROLES.TRAVEL_COMPANY_ADMIN] },
  { value: USER_ROLES.TRAVEL_COMPANY_AGENT, text: USER_LIST_NAMES[USER_ROLES.TRAVEL_COMPANY_AGENT] },
  // LAF ROLES
  { value: USER_ROLES.HANDLING_COMPANY_MANAGER, text: USER_LIST_NAMES[USER_ROLES.HANDLING_COMPANY_MANAGER] },
  { value: USER_ROLES.HANDLING_COMPANY_AGENT, text: USER_LIST_NAMES[USER_ROLES.HANDLING_COMPANY_AGENT] },
  { value: USER_ROLES.HANDLING_COMPANY_OPERATOR, text: USER_LIST_NAMES[USER_ROLES.HANDLING_COMPANY_OPERATOR] },
  { value: USER_ROLES.HANDLING_COMPANY_OBSERVER, text: USER_LIST_NAMES[USER_ROLES.HANDLING_COMPANY_OBSERVER] },
];
